import React from 'react';
import { Navigate } from 'react-router';
import PropTypes from 'prop-types';

const PrivateRoute = ({ children, hasPrivilege }) =>
  hasPrivilege ? children : <Navigate to="/" replace />;

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  hasPrivilege: PropTypes.bool.isRequired,
};

export default PrivateRoute;
